/*
Docs:
https://redux.js.org/api/store#subscribelistener
https://github.com/reduxjs/redux/issues/303#issuecomment-125184409
*/
export const observeStore = (store, onChange, select) => {
  let currentState;

  const handleChange = () => {
    const state = store.getState();
    const nextState = select ? select(state) : state;

    if (nextState !== currentState) {
      currentState = nextState;

      onChange(currentState);
    }
  };

  const unsubscribe = store.subscribe(handleChange);

  handleChange();

  return unsubscribe;
};
